var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.703413 1.46469L6.5531 7.52534C6.73688 7.70992 7.02812 7.72077 7.22454 7.55791L7.26021 7.52534L13.2938 1.46496C13.3187 1.43997 13.3327 1.40615 13.3327 1.37089V0.328646C13.3327 0.255008 13.273 0.195312 13.1993 0.195312C13.1639 0.195312 13.1299 0.20944 13.1049 0.234571L6.92658 6.43982L0.89491 0.240994C0.843556 0.188218 0.759142 0.187064 0.706365 0.238417C0.680568 0.263519 0.666016 0.297984 0.666016 0.333978V1.37209C0.666016 1.40664 0.679423 1.43983 0.703413 1.46469Z",
    fill: "#266128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.9cce2221733da39faf63cbea700bc781.svg";
export { ForwardRef as ReactComponent };